import { EActionState, ICampaignSetting, IRegionCampaign } from '@/models';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { regionCampaignService } from '@/services/regioncampaign.service';

export const regionCampaignsSlice = createSlice({
	name: '@@regionCampaigns',
	initialState: initialState,
	reducers: {
		LOAD_REGION_CAMPAIGNS_START: (
			state,
			action: PayloadAction<{
				company?: string;
				businessUnit?: string;
				serviceRegion?: string;
			}>
		) => {
			state.region = {
				company: action.payload?.company ?? '',
				businessUnit: action.payload?.businessUnit ?? '',
				serviceRegion: action.payload?.serviceRegion ?? ''
			};
			state.regionCampaign.loaded = EActionState.RUNNING;
		},
		LOAD_REGION_CAMPAIGNS_COMPLETED: (
			state,
			action: PayloadAction<IRegionCampaign>
		) => {
			state.regionCampaign.data = action.payload;
			state.regionCampaign.loaded = EActionState.COMPLETED;
		},
		LOAD_REGION_CAMPAIGNS_FAILED: state => {
			state.regionCampaign.data = initialState.regionCampaign.data;
			state.regionCampaign.loaded = EActionState.FAILED;
		},
		LOAD_ALL_REGION_CAMPAIGNS_START: state => {
			state.regionCampaigns.loaded = EActionState.RUNNING;
		},
		LOAD_ALL_REGION_CAMPAIGNS_COMPLETED: (
			state,
			action: PayloadAction<IRegionCampaign[]>
		) => {
			state.regionCampaigns.data = action.payload;
			state.regionCampaigns.loaded = EActionState.COMPLETED;
			regionCampaignService.setCampaigns(state);
		},
		LOAD_ALL_REGION_CAMPAIGNS_FAILED: state => {
			state.regionCampaigns.data = initialState.regionCampaigns.data;
			state.regionCampaigns.loaded = EActionState.FAILED;
		},
		UPDATE_CAMPAIGN_START: (
			state,
			action: PayloadAction<{ key: string; enabled: boolean }>
		) => {
			state.regionCampaignUpdate.data = {
				key: action.payload.key,
				enabled: action.payload.enabled,
				company: state.region.company,
				businessUnit: state.region.businessUnit,
				serviceRegion: state.region.serviceRegion
			};
			state.regionCampaignUpdate.loaded = EActionState.RUNNING;
		},
		UPDATE_CAMPAIGN_COMPLETED: (
			state,
			action: PayloadAction<{
				regionCampaign: IRegionCampaign;
				regionCampaigns?: IRegionCampaign[];
			}>
		) => {
			state.regionCampaign.data = action.payload.regionCampaign;
			if (action.payload.regionCampaigns) {
				state.regionCampaigns.data = action.payload.regionCampaigns;
				regionCampaignService.setRegionsByCampaign(state);
			}
			state.regionCampaignUpdate.data =
				initialState.regionCampaignUpdate.data;
			state.regionCampaignUpdate.loaded = EActionState.COMPLETED;
		},
		UPDATE_CAMPAIGN_FAILED: state => {
			state.regionCampaignUpdate.data =
				initialState.regionCampaignUpdate.data;
			state.regionCampaignUpdate.loaded = EActionState.FAILED;
		},
		SET_CAMPAIGN_SETTING_KEY: (
			state,
			action: PayloadAction<ICampaignSetting | null>
		) => {
			state.campaignSetting = action.payload;
			regionCampaignService.setRegionsByCampaign(state);
		},
		SET_REGION_CAMPAIGN_UPDATE: (
			state,
			action: PayloadAction<IRegionCampaign>
		) => {
			regionCampaignService.setRegionCampaignUpdate(
				state,
				action.payload
			);
		},
		UPDATE_REGIONS_START: state => {
			state.regionCampaignUpdates.loaded = EActionState.RUNNING;
		},
		UPDATE_REGIONS_COMPLETED: (
			state,
			action: PayloadAction<{
				regionCampaigns: IRegionCampaign[];
				regionCampaign?: IRegionCampaign;
			}>
		) => {
			state.regionCampaigns.data = action.payload.regionCampaigns;
			if (action.payload.regionCampaign) {
				state.regionCampaign.data = action.payload.regionCampaign;
			}
			state.regionCampaignUpdates = initialState.regionCampaignUpdates;
			regionCampaignService.setRegionsByCampaign(state);
		},
		UPDATE_REGIONS_FAILED: state => {
			state.regionCampaignUpdates.loaded = EActionState.FAILED;
		}
	}
});

export const actionCreator = regionCampaignsSlice.actions;
export const reducer = regionCampaignsSlice.reducer;
